import ImageBanner from '@components/ImageBanner'
import type { pageTitle, pageContent } from '@lib/types'
import { getPageTitleContentFromDB, getPageContentFromDB } from '@lib/pagequerys'
import type { GetStaticProps } from 'next'
import { Container, Heading, Section, Text, List } from '@components/SectionComponents'
import MapComponent from '@components/MapComponent/mapComponent'

export const getStaticProps: GetStaticProps = async () => {

  // page_id in DB
  const pageIdDB: number = 16;

  // query DB for page title data
  const pageTitle: pageTitle = await getPageTitleContentFromDB(pageIdDB);

  // Array of pageContent - query DB for pageContent data
  const pageContent: pageContent[] = await getPageContentFromDB(pageIdDB);

  return {
    props: {
      pageTitle,
      pageContent
    }
  }
}

// Home Page takes a pageTitle, and pageContent array
export default function Page({ pageTitle, pageContent }: {
  pageTitle: pageTitle,
  pageContent: pageContent[],
}) {

  return (
    <>
      <ImageBanner title={pageTitle} isHome={false} />

      {/* Section 0 */}
      <Section colour='brown'>
        <Container soloHeader={true}>
          <Heading h1={true} content={{title: pageContent[0].title}} />
          <MapComponent />
        </Container>
        
      </Section>

      {/* Section 1 */}
      <Section colour='white'>
        <Container>
          <Heading content={{ title: pageContent[1].title }} />
          <Text content={pageContent[1].text} />
        </Container>
      </Section>

      {/* Section 2 */}
      <Section colour='cream'>
        <Container>
          <Heading content={{
            title: pageContent[2].title,
            subtitle: pageContent[2].subtitle,
          }} />
          <List ul={false} content={pageContent[2].list} underHeading={true} />
        </Container>
      </Section>

      {/* Section 3 */}
      <Section colour='brown'>
        <Container>
        <Heading content={{
            title: pageContent[3].title,
            subtitle: pageContent[3].subtitle,
          }} />
          <List ul={false} content={pageContent[3].list} underHeading={true} />
        </Container>
      </Section>

      {/* Section 4 */}
      <Section colour='dark'>
        <Container>
          <Heading content={{ title: pageContent[4].title }} />
          <Text content={pageContent[4].text} />
        </Container>
      </Section>

      {/* Section 5 */}
      <Section colour='white'>
        <Container>
          <Heading content={{ title: pageContent[5].title }} />
          <Text content={pageContent[5].text} />
        </Container>
      </Section>

    </>
  )
}

//Meta Data
Page.title = "Directions";
Page.description = "The Sunshine Coast is easily accessible by a number of major highways. The Crocodile Hunter Lodge is located on 88 Irwin Road in Beerwah, and is approximately a 60-minute drive from Brisbane via the Bruce Highway.";